import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'

const schema: LandingScreenSchema = {
	order: ['LandingHead', 'LandingTitle', 'LandingImage', 'LandingProgressLoader', 'LandingFooter'],

	components: {
		LandingTitle: (): LandingComponentsConfig['LandingTitle'] => ({
			title: '30-Day Ramadan Fasting Plan to Support Your Body',
			size: 'small',
		}),

		LandingImage: (): LandingComponentsConfig['LandingImage'] => ({
			img: require('@/assets/landing/ramadan-f.webp'),
			customStyles: {
				width: 'calc(100% + 40px)',
				maxWidth: 'none',
				marginLeft: '-20px',
				marginRight: '-20px',
				marginTop: 'var(--size-24)',
				marginBottom: 'var(--size-24)',
			},
		}),

		LandingProgressLoader: (): LandingComponentsConfig['LandingProgressLoader'] => ({
			duration: 3500,
		}),
	},
}

export default schema
